export enum TizenNetworkState {
  INTERNET_CONNECTED = 0,
  LAN_CABLE_ATTACHED = 1,
  LAN_CABLE_DETACHED = 2,
  LAN_CABLE_STATE_UNKNOWN = 3,
  GATEWAY_CONNECTED = 4,
  GATEWAY_DISCONNECTED = 5,
  WIFI_MODULE_STATE_ATTACHED = 6,
  WIFI_MODULE_STATE_DETACHED = 7,
  WIFI_MODULE_STATE_UNKNOWN = 8,
  INTERNET_DISCONNECTED = 9,
}

export enum TizenNetworkActiveConnectionType {
  DISCONNECTED = 0,
  WIFI = 1,
  CELLULAR = 2,
  ETHERNET = 3,
}

export enum TizenNetworkIpMode {
  NONE = 0,
  STATIC = 1,
  DYNAMIC = 2,
  AUTO = 3,
  FIXED = 4,
  UNKNOWN = 5,
}

export interface TizenSystemInfoCpu {
  load: number
}

export interface TizenSystemInfoStorage {
  units: TizenSystemInfoStorageUnit[]
}

export interface TizenSystemInfoStorageUnit {
  type: string
  capacity: number
  availableCapacity: number
  isRemovable: boolean
}

export interface TizenSystemInfoDisplay {
  resolutionWidth: number
  resolutionHeight: number
  dotsPerInchWidth: number
  dotsPerInchHeight: number
  physicalWidth: number
  physicalHeight: number
  brightness: number
}

export interface TizenSystemInfoPanel {
  panelWidth: number
  panelHeight: number
}

export interface TizenSystemInfoDeviceOrientation {
  status: string
  isAutoRotation: boolean
}

export interface TizenSystemInfoBuild {
  model: string
  manufacturer: string
  buildVersion: string
}

export interface TizenSystemInfoLocale {
  language: string
  country: string
}

export interface TizenSystemInfoNetwork {
  networkType: string
}

export interface TizenSystemInfoWifiNetwork {
  status: string
  ssid: string
  ipAddress: string
  ipv6Address: string
  macAddress: string
  signalStrength: number
  securityMode: string
  encryptionType: string
  ipMode: string
  subnetMask: string
  gateway: string
  dns: string
}

export interface TizenSystemInfoEthernetNetwork {
  cable: string
  status: string
  ipAddress: string
  ipv6Address: string
  macAddress: string
  ipMode: string
  subnetMask: string
  gateway: string
  dns: string
}

export interface TizenSystemInfoCellularNetwork {
  status: string
  apn: string
  ipAddress: string
  ipv6Address: string
  mcc: number
  mnc: number
  cellId: number
  lac: number
  isRoaming: boolean
  isFlightMode: boolean
  imei: string
  ipMode: string
  subnetMask: string
  gateway: string
  dns: string
}

export interface TizenSystemInfoProxyNetwork {
  status: string
}

export interface TizenSystemInfoCellularNetwork {
  state: string
  operatorName: string
  msisdn: string
  iccid: string
  mcc: number
  mnc: number
  msin: string
  spn: string
}

export interface TizenSystemInfoPeripheral {
  isVideoOutputOn: boolean
}

export interface TizenSystemInfoMemory {
  status: string
}

export interface TizenSystemInfoVideoSourceInfo {
  type: string
  number: number
  signal?: boolean
  editName?: string
}

export interface TizenSystemInfoVideoSource {
  connected: TizenSystemInfoVideoSourceInfo[]
  disconnected: TizenSystemInfoVideoSourceInfo[]
}

export interface TizenSystemInfoServiceCountry {
  serviceCountry: string
}

export interface TizenSubtitleInfo {
  language: string
  index: number
  mode: TizenSubtitleMode
}

export enum TizenSubtitleMode {
  NORMAL = 'NORMAL',
  HEARING_IMPAIRED = 'HEARING_IMPAIRED',
}

export interface TizenAudioInfo {
  language: string
  index: number
  type: TizenAudioType
}

export enum TizenAudioType {
  INVALID = 'INVALID',
  UNDEFINED = 'UNDEFINED',
  CLEAN_EFFECT = 'CLEAN_EFFECT',
  HEARING_IMPAIRED = 'HEARING_IMPAIRED',
  VISUAL_IMPAIRED = 'VISUAL_IMPAIRED',
}

export enum TizenPalettePowerOffMode {
  ON = 'ON',
  OFF = 'OFF',
}

export interface TizenPalettePowerOffInfo {
  mode: TizenPalettePowerOffMode
  savedImageFolderPath?: string
}

export enum TizenPalettePlayMode {
  GEN_WALLPAPER = 'GEN_WALLPAPER',
  EXTERNAL_CONNECTION = 'EXTERNAL_CONNECTION',
}

export interface TizenPaletteScheduleInfo {
  enable: boolean
  onTime: string // HH:mm
  offTime: string // HH:mm
}

export enum TizenPaletteRotationTime {
  OFF = 'OFF',
  MIN_10 = 'MIN_10',
  MIN_30 = 'MIN_30',
  MIN_60 = 'MIN_60',
}

export enum TizenPaletteDisplayOption {
  IN_ORDER = 'IN_ORDER',
  SHUFFLE = 'SHUFFLE',
}

export enum TizenPaletteNightMode {
  ON = 'ON',
  OFF = 'OFF',
}

export enum TizenPaletteMotionSleepTime {
  OFF = 'OFF',
  MIN_5 = 'MIN_5',
  MIN_15 = 'MIN_15',
  MIN_30 = 'MIN_30',
  MIN_60 = 'MIN_60',
  MIN_120 = 'MIN_120',
  MIN_240 = 'MIN_240',
}

export enum TizenPaletteMotionDetector {
  LOW = 'LOW',
  MIDDLE = 'MIDDLE',
  HIGH = 'HIGH',
}
